"use client";
import { createContext, useContext } from "react";

interface Props {
  selectedData: any;
  icon: any;
  setSelectedData: (data: any) => void;
  isFocused: boolean;
}

export const QuoteAutocompleteContext = createContext<Props>({
  selectedData: {},
  icon: "",
  setSelectedData: () => {},
  isFocused: false,
});

export const QuoteAutocompleteProvider = (props: Props & { children: any }) => {
  return (
    <QuoteAutocompleteContext.Provider value={{ ...props }}>
      {props.children}
    </QuoteAutocompleteContext.Provider>
  );
};

export const useQuoteAutocomplete = () => {
  return useContext(QuoteAutocompleteContext);
};
